module.exports = __webpack_public_path__ + "img/signing_options.518fc735.jpg";